var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item)?_c('span',[_vm._v(" "+_vm._s(_vm.item.credit)+"("+_vm._s(_vm.item.lect_hr)+"-"+_vm._s(_vm.item.prac_hr)+"-"+_vm._s(_vm.item.self_hr)+") "),(_vm.show_lect_or_prac)?_c('lect-or-prac-chip',{attrs:{"item":_vm.item}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }